/**
 * In-memory placeholder images (SVG data URIs). Avoids via.placeholder.com and similar
 * CDNs that often fail with net::ERR_CONNECTION_CLOSED (firewall, region, or downtime).
 */

function escapeSvgText(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

/**
 * @param {number} width
 * @param {number} height
 * @param {string} [label]
 * @returns {string} data:image/svg+xml URL
 */
export function placeholderDataUrl(width, height, label = '') {
  const w = Math.max(1, Math.min(4000, Number(width) || 400));
  const h = Math.max(1, Math.min(4000, Number(height) || 300));
  const t = escapeSvgText(label.slice(0, 48));
  const fontSize = Math.max(10, Math.min(28, Math.floor(Math.min(w, h) / 10)));
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
  <rect fill="#e9ecef" width="100%" height="100%"/>
  ${t ? `<text x="50%" y="50%" dominant-baseline="middle" text-anchor="middle" fill="#868e96" font-family="system-ui,sans-serif" font-size="${fontSize}">${t}</text>` : ''}
</svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
}

/** Stable URL for “no image” fallbacks (small cart / order thumbnails). */
export const PLACEHOLDER_NO_IMAGE_SMALL = placeholderDataUrl(140, 170, 'No image');
export const PLACEHOLDER_NO_IMAGE_TINY = placeholderDataUrl(100, 120, 'No image');
export const PLACEHOLDER_NO_IMAGE_MINI = placeholderDataUrl(80, 100, 'No image');
